import { render, staticRenderFns } from "./requestBySector.vue?vue&type=template&id=38685b29"
import script from "./requestBySector.vue?vue&type=script&lang=js"
export * from "./requestBySector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports